// Hefty regex to check email syntax validity without adding any dependencies!
// See: http://emailregex.com/

// eslint-disable-next-line security/detect-unsafe-regex
export default /^(([^\s"(),.:;<>@\\\]]+(\.[^\s"(),.:;<>@\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/;